import React, { FC } from 'react';
import { Skeleton } from '@material-ui/lab';
import { useStyles } from './styles';
import SkeletonBoxProps from './interface';

const SkeletonBox: FC<SkeletonBoxProps> = ({ width, height, className }) => {
  const classes = useStyles();

  return (
    <Skeleton
      variant="rect"
      width={width}
      height={height}
      className={[classes.rounded, className].join(' ')}
    />
  );
};

const SkeletonCard = () => {
  const classes = useStyles();
  return (
    <div className={classes.skeletonCard}>
      <SkeletonBox height={69} className={classes.roundedTop} />

      <div className={classes.content}>
        <div className={classes.header}>
          <SkeletonBox width={282} height={30} />
          <SkeletonBox width={201} height={30} />
        </div>

        <div className={classes.avatar}>
          <Skeleton variant="circle" width={48} height={48} />
          <div className={classes.avatarText}>
            <SkeletonBox width={70} height={20} />
            <SkeletonBox width={70} height={20} />
          </div>
        </div>

        <div className={classes.footer}>
          <SkeletonBox width={201} height={30} />
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;
